const ROUTES = {
  "/": {
    "name": "HomePageE1ce4a26A10145c69e87360c34d03f4c",
    "type": "HTML",
    "key": "home-page"
  },
  "/about": {
    "name": "AboutUsPage12bd26b2E7e743d3A6f11d0661bd7b1e",
    "type": "HTML",
    "key": "about-us-page"
  },
  "/about/local-partnership": {
    "name": "LocalPartnershipPage834593b5645e40069586387f5d2aba0e",
    "type": "HTML",
    "key": "local-partnership-page"
  },
  "/apply/*": {
    "name": "ApplicationPages68b863e0Ef19409cBdbfD049601391c7",
    "type": "REFERENCE",
    "key": "application-pages"
  },
  "/contact": {
    "name": "PublicContactPage7ba043e3517c475f930dE261b126e2d6",
    "type": "HTML",
    "key": "public-contact-page"
  },
  "/events/public": {
    "name": "PublicEventsPageD7f6752128ca4010A12113ca3c6da302",
    "type": "HTML",
    "key": "public-events-page"
  },
  "/faq": {
    "name": "PublicFaqPageE56e468c71e9457390519c528382b472",
    "type": "HTML",
    "key": "public-faq-page"
  },
  "/join": {
    "name": "JoinUsPageD4c2730172d04144A4d933d4523cc5d8",
    "type": "HTML",
    "key": "join-us-page"
  }
};

export default ROUTES;